export default "__VITE_ASSET__n67m$dia__"